// Created with: https://react-svgr.com/playground/?icon=true&ref=true&replaceAttrValues=%23fff%3DcurrentColor&svgoConfig=%7B%22plugins%22%3A%5B%7B%22name%22%3A%22preset-default%22%2C%22params%22%3A%7B%22overrides%22%3A%7B%22removeTitle%22%3Afalse%2C%22removeViewBox%22%3Afalse%7D%7D%7D%5D%7D&titleProp=true&typescript=true

/* <svg width="6" height="10" viewBox="0 0 6 10" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M1 8.509L4.61011 4.754L1 1" stroke="white" stroke-width="2"/>
</svg> */

import { SVGProps, Ref, forwardRef } from 'react'

interface SVGRProps {
  title?: string
  titleId?: string
}

const SvgComponent = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 6 10"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ?
      <title id={titleId}>{title}</title>
    : null}
    <path stroke="currentColor" strokeWidth={2} d="m1 8.509 3.61-3.755L1 1" />
  </svg>
)

const ForwardRef = forwardRef(SvgComponent)

export default ForwardRef
